import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactTable from 'react-table';
import history from '../../../../history';

import actions from '../../../../actions';
import ActionButton from '../../../common/ActionButton';
import StatusCell from '../../../common/StatusCell';
import PopupHeader from '../../../common/PopupHeader';

class CancelShiftContainer extends Component {
    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
        this.onProceed = this.onProceed.bind(this);
    }

    onCancel = () => {
        history.push('/jobs/list');
    };

    onProceed = () => {
        // eslint-disable-next-line react/prop-types
        const selected = this.props.selected ? this.props.selected : [];
        if (selected.length === 0) {
            history.push('/jobs/list');
            // eslint-disable-next-line react/prop-types
            this.props.reloadShifts();
            return;
        }
        // eslint-disable-next-line react/prop-types
        this.props.cancel(selected);
    };

    columns = [
        {
            Header: 'Ref',
            accessor: 'reference_number',
            id: 'reference_number',
            sortable: false,
            className: 'job-container-modal-cell',
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: row => <StatusCell status={row.value} />,
            className: 'job-container-modal-cell',
        },
        {
            Header: 'Date',
            accessor: 'date',
            Cell: row => moment(row.value).format('DD/MM/YYYY'),
            className: 'job-container-modal-cell',
        },
    ];

    render() {
        // eslint-disable-next-line react/prop-types
        const selected = this.props.selected ? this.props.selected : [];
        const proceed = selected.length === 0 ? 'Close' : 'Proceed';
        const subtitle =
            'Are you sure you want to cancel the following shifts?';
        return (
            <div className="cancel-shift">
                <PopupHeader
                    title="Cancel shifts"
                    subtitle={subtitle}
                    onDismiss={this.onCancel}
                />
                <div>
                    <ReactTable
                        pageSize={5}
                        data={selected}
                        columns={this.columns}
                        className="modal-table"
                        showPageSizeOptions={false}
                    />
                </div>
                <div className="modal-bottom-bar">
                    <ActionButton
                        onAction={this.onCancel}
                        text="Cancel"
                        // eslint-disable-next-line react/prop-types
                        disabled={this.props.fetching || selected.length === 0}
                    />
                    <ActionButton
                        onAction={this.onProceed}
                        text={proceed}
                        // eslint-disable-next-line react/prop-types
                        loading={this.props.fetching}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state.shifts.selections,
});

const mapDispatchToProps = dispatch => ({
    cancel: selected => dispatch(actions.cancelShifts(selected)),
    reloadShifts: () => dispatch(actions.loadShifts()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CancelShiftContainer);
